import { Instagram, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="pt-20 pb-10 px-6 mt-8 border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center gap-8">

        {/* Znipd Logo */}
        <img
          src="https://customer-assets.emergentagent.com/job_restaurant-radar-8/artifacts/o5cdz2z8_ZnipdOrangePurple.png"
          alt="Znipd"
          className="w-56 sm:w-72 h-auto object-contain select-none"
        />

        {/* Social Links */}
        <div className="flex items-center gap-8 flex-wrap justify-center">
          <a
            data-testid="footer-instagram-link"
            href="https://www.instagram.com/zni.pd"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 font-manrope text-[#8A8A93] hover:text-[#F0F0EE] transition-colors duration-200 text-sm"
          >
            <Instagram size={16} />
            <span>Instagram @znipd</span>
          </a>

          <span className="text-white/10 hidden sm:block">|</span>

          <a
            data-testid="footer-facebook-link"
            href="https://www.facebook.com/znipd/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 font-manrope text-[#8A8A93] hover:text-[#F0F0EE] transition-colors duration-200 text-sm"
          >
            <Facebook size={16} />
            <span>Facebook Group</span>
          </a>
        </div>

        {/* Tagline */}
        <p className="font-manrope text-[#8A8A93] text-sm tracking-widest uppercase">
          Community Intelligence. Starting in Dallas.
        </p>

        {/* Copyright */}
        <p className="font-manrope text-[#8A8A93]/40 text-xs">
          © 2026 Znipd
        </p>
      </div>
    </footer>
  );
};

export default Footer;
